<footer>
    <div>
        <span>{{textDeveloped}}</span>
    </div>
</footer>